"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    roleId: zod_1.z.number(),
});
exports.path = '/admin-delete-role';
//# sourceMappingURL=index.js.map